export default {
    title: state => state.notification.title,
    icon: state => state.notification.icon,
    maintenance: state => state.maintenance,
    allNotifications: state => state.allNotifications,
    lastNotificationsPageIndex: state => state.lastNotificationsPageIndex,
    isLoading: state => state.isLoading
}
